// [claude-code 2026-04-29] S49: Unwrap { plan } wrapper from /api/day-plan/today.
//   Backend returns { plan: DayPlan | null }; previously the hook cast the
//   response body directly as DayPlan so data.windows was always undefined.
// [claude-code 2026-04-26] S45-T2: useDayPlan — GET /api/day-plan/today on mount,
//   60s poll. Mirrors useIVScoreData shape: {data, isLoading, error}.
import { useState, useEffect, useRef } from "react";
import type { DayPlan } from "../types/day-plan";

const API_BASE = import.meta.env.VITE_API_URL || "http://localhost:8080";
const POLL_INTERVAL = 60_000;
export const DAY_PLAN_REFETCH_EVENT = "fintheon:day-plan-refetch";

export function useDayPlan() {
  const [data, setData] = useState<DayPlan | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

  useEffect(() => {
    let cancelled = false;

    async function fetchPlan() {
      try {
        const res = await fetch(`${API_BASE}/api/day-plan/today`);
        if (!res.ok) {
          if (!cancelled) {
            setError(`HTTP ${res.status}`);
            setIsLoading(false);
          }
          return;
        }
        const json = (await res.json()) as { plan: DayPlan | null };
        if (!cancelled) {
          setData(json.plan ?? null);
          setError(null);
          setIsLoading(false);
        }
      } catch {
        if (!cancelled) {
          setError("Network error");
          setIsLoading(false);
        }
      }
    }

    fetchPlan();
    window.addEventListener(DAY_PLAN_REFETCH_EVENT, fetchPlan);
    intervalRef.current = setInterval(fetchPlan, POLL_INTERVAL);

    return () => {
      cancelled = true;
      window.removeEventListener(DAY_PLAN_REFETCH_EVENT, fetchPlan);
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, []);

  return { data, isLoading, error };
}
